<template>
  <ol class="password-rules">
    <li>Длина пароля не менее 12 символов, содержит хотя бы одну заглавную букву, одну цифру и один спец. символ</li>
    <li>Пароль не должен содержать личную информацию и идентификатор профиля или имя</li>
    <li>Новый пароль не должен совпадать с предыдущими значениями</li>
  </ol>
</template>

<script>
export default {
  name: 'PasswordRules',
};
</script>

<style lang="scss">
.password-rules {
    margin-top: 10px;
    padding-left: 10px;
    font-size: 14px;
}
</style>
